import config from '@/config/config.js';

export function getTemplateDetailUrl(item) {
	if (config.devEnv === 'online') {
		return config.mianDomain + item.detail_url;
	}
	return `/gEditTemplateDetail.html?id=${encodeURIComponent(item.id)}`;
}

export function getTemplateListUrl() {
	if (config.devEnv === 'online') {
		return config.mianDomain + '/moban';
	}
	return '/gEditTemplateList.html';
}

export function getEditorUrl({ templateId, blank = false, idKey = '', asTpl = false } = {}) {
	const params = new URLSearchParams();
	if (blank) params.set('blank', '1');
	if (idKey) params.set('id_key', idKey);
	if (templateId) params.set('template_id', String(templateId));
	if (asTpl) params.set('as_tpl', '1');
	const query = params.toString();
	if(config.devEnv === 'online'){
		return config.mianDomain + '/edit?' + query;
	}
	return query ? `/gEdit.html?${query}` : '/gEdit.html';
}

export function getTemplatePreviewUrl(id) {
	return `/preview.html?gedit=1&template_id=${encodeURIComponent(id)}`;
}

export function parseQueryString(search = window.location.search) {
	const params = new URLSearchParams(search);
	return {
		templateId: params.get('template_id') || '',
		idKey: params.get('id_key') || '',
		blank: params.get('blank') === '1',
		asTpl: params.get('as_tpl') === '1',
		page: Math.max(1, Number(params.get('page')) || 1),
	};
}

export function resolveTplTextField(title) {
	const text = String(title || '').trim();
	return text || ' ';
}

export function buildTplAddPayload({ idKey, title }) {
	const text = resolveTplTextField(title);
	return {
		id_key: idKey,
		title: text,
		keywords: text,
		description: text,
		sort: 0,
		cover_attach_id: 0,
		status: 1,
		stick: 0,
		tag_ids: JSON.stringify([]),
		content: JSON.stringify(createDefaultTplCardContent()),
	};
}

export function normalizeTplTagIds(raw) {
	let list = raw;
	if (typeof raw === 'string') {
		try {
			list = JSON.parse(raw || '[]');
		} catch (e) {
			list = String(raw)
				.split(',')
				.map((item) => item.trim())
				.filter(Boolean);
		}
	}
	if (!Array.isArray(list)) {
		if (raw == null || raw === '') return [];
		list = [raw];
	}
	return [...new Set(list.map((item) => {
		if (item && typeof item === 'object') return Number(item.id);
		return Number(item);
	}).filter((id) => Number.isFinite(id) && id > 0))];
}

export function createDefaultTplCardContent() {
	return {
		isHot: true,
		subtitle: '专为私域引流与转化而设计的优质模板，助你高效搭建内容营销场景。',
		features: [
			{ title: '内容营销', subtitle: '高转化设计' },
			{ title: '私域引流', subtitle: '高转化设计' },
			{ title: '转化漏斗', subtitle: '高转化设计' },
		],
		stats: [
			{ icon: 'mbm-tuandui', title: '私域转化', subtitle: '沉淀用户' },
			{ icon: 'mbm-tongjibaobiao', title: '适合投流', subtitle: '转化度高' },
		],
	};
}

export function parseTplCardContent(raw) {
	let data = raw;
	if (typeof raw === 'string') {
		try {
			data = JSON.parse(raw || '{}');
		} catch (e) {
			data = {};
		}
	}
	if (!data || typeof data !== 'object' || Array.isArray(data)) {
		data = {};
	}

	const defaults = createDefaultTplCardContent();
	const features = Array.isArray(data.features)
		? data.features.slice(0, 3).map((item, index) => ({
			title: String(item?.title ?? defaults.features[index]?.title ?? '').trim(),
			subtitle: String(item?.subtitle ?? defaults.features[index]?.subtitle ?? '').trim(),
		}))
		: defaults.features.map((item) => ({ ...item }));

	while (features.length < 3) {
		const fallback = defaults.features[features.length] || { title: '', subtitle: '' };
		features.push({ ...fallback });
	}

	const statsSource = Array.isArray(data.stats) && data.stats.length
		? data.stats
		: defaults.stats;

	return {
		isHot: parseTplBool(data.isHot ?? data.is_hot, true),
		subtitle: String(data.subtitle ?? defaults.subtitle).trim(),
		features,
		stats: statsSource.slice(0, 6).map((item) => ({
			icon: String(item?.icon || '').trim().replace(/^mbm-iconfont\s+/, ''),
			title: String(item?.title || '').trim(),
			subtitle: String(item?.subtitle || '').trim(),
		})),
	};
}

export function parseTplBool(value, fallback = false) {
	if (value === true || value === 1 || value === '1') return true;
	if (value === false || value === 0 || value === '0') return false;
	if (typeof value === 'string') {
		const normalized = value.trim().toLowerCase();
		if (normalized === 'true') return true;
		if (normalized === 'false') return false;
	}
	if (value == null || value === '') return fallback;
	return Boolean(value);
}

export function normalizeTplListItem(item = {}) {
	const content = parseTplCardContent(item.content);
	return {
		id: item.id,
		title: item.title || '未命名模板',
		subtitle: content.subtitle || item.description || '',
		cover: item.cover || item.qrcode_path || item.qrcode_url || '',
		description: item.description || '',
		keywords: item.keywords || '',
		sort: Number(item.sort) || 0,
		status: item.status === 0 ? 0 : (item.status ?? 1),
		stick: item.stick === 1 ? 1 : 0,
		cover_attach_id: Number(item.cover_attach_id) || 0,
		qrtype: item.qrtype,
		qrcode_url: item.qrcode_url || '',
		qrcode_path: item.qrcode_path || '',
		use_url: item.use_url || '',
		tag_ids: normalizeTplTagIds(item.tag_ids || item.tags),
		content,
		isHot: content.isHot,
		features: content.features,
		stats: content.stats,
		tags: content.features.map((f) => f.title).filter(Boolean),
		heat: item.heat || '',
		views: item.views || '',
		detail_url: item.detail_url || '',
	};
}
